import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { StarRating } from './StarRating';
import styles from './RatingCheckboxList.module.scss';
export function RatingCheckboxList({ options, onChange, initialShow = 6, }) {
    const [showAll, setShowAll] = useState(false);
    const [optimisticOptions, setOptimisticOptions] = useState(options);
    // Update optimistic options when props change (API response)
    useEffect(() => {
        setOptimisticOptions(options);
    }, [options]);
    const starOptions = optimisticOptions.map(option => {
        let starCount = 1;
        if (option.rating) {
            starCount = Math.ceil(option.rating);
        }
        else if (option.id) {
            const fromValue = parseFloat(option.id.split('-')[0]);
            starCount = Math.ceil(fromValue);
        }
        return Object.assign(Object.assign({}, option), { starCount, label: `${starCount} Stars` });
    }).sort((a, b) => b.starCount - a.starCount);
    const visibleOptions = showAll ? starOptions : starOptions.slice(0, initialShow);
    const handleCheckboxChange = (originalId) => {
        // Optimistically update the UI immediately
        setOptimisticOptions(prevOptions => prevOptions.map(option => {
            if (option.id === originalId) {
                return Object.assign(Object.assign({}, option), { selected: !option.selected });
            }
            return option;
        }));
        // Call the actual onChange handler
        onChange(originalId);
    };
    return (h("div", { className: styles.ratingCheckboxList },
        visibleOptions.map((option) => (h("label", { key: option.id, className: styles.checkboxLabel },
            h("input", { type: "checkbox", checked: option.selected, onChange: () => handleCheckboxChange(option.id) }),
            h("div", { className: styles.ratingContent },
                h(StarRating, { starChecked: option.selected, rating: option.starCount || 0 })),
            h("span", { className: `${styles.count} ${option.selected ? styles.selected : ''}` }, option.count)))),
        starOptions.length > initialShow && (h("button", { className: styles.showMore, onClick: () => setShowAll(!showAll) }, showAll ? 'Show Less' : `Show ${starOptions.length - initialShow} More`))));
}
